import { useEffect } from 'react';

/**
 * This hook takes in a reference element or component and attaches an event listener
 * Once a mousedown event has been triggered outside the element, the callback is invoked.
 *
 * @param {Ref} ref // DOM element or React class component
 * @param {Function} callback // To be invoked once a click outside is detected
 * @param {Array} deps // Additional dependencies for the inner useEffect hook
 */
export const useDetectOutsideClick = (ref, callback, deps = []) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref && ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    // Removes the event listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...deps]);
};
